<svelte:head>
<!-- If you'd like to support IE8 (for Video.js versions prior to v7) -->
<script src="https://vjs.zencdn.net/ie8/1.1.2/videojs-ie8.min.js"></script>
<script src="https://vjs.zencdn.net/7.7.5/video.js"></script>
</svelte:head>

<style src="./style.scss">

</style>

<div class="mbsc-row">
  <div class="mbsc-col-12">
    <video
      disableRemotePlayback
      class="video-js d-ns-main-player {videoClass}"
      controls
      preload="auto"
      width="640"
      height="360"
      poster={poster}
    >
      {#if frontBlobUrl !== null}
      <source src={frontBlobUrl} type="application/x-mpegURL" />
      {:else if frontCamera}
      <source src={frontCamera} type="application/x-mpegURL" />
      {/if}
      {#if backBlobUrl !== null}
      <source src={backBlobUrl} type="application/x-mpegURL" />
      {:else if backCamera !== null}
      <source src={backCamera} type="application/x-mpegURL" />
      {/if}
      <p class="vjs-no-js">
        To view this video please enable JavaScript, and consider upgrading to a
        web browser that
        <a href="https://videojs.com/html5-video-support/" target="_blank"
          >supports HTML5 video</a
        >
      </p>
    </video>
  </div>
</div>

<script>
  import { onMount, afterUpdate, createEventDispatcher } from 'svelte';

  import videojs from 'video.js';

  import DNSBar from '@Components/DNSBar/component.js';
  import MirrorSource from '@Components/MirrorSource/component.js';
  import DownloadVideo from '@Components/DownloadVideo/component.js';
  import StartRecording from '@Components/StartRecording/component.js';
  import ToggleSource from '@Components/ToggleSource/component.js';
  import LoopSourceButton from '@Components/LoopSourceButton/component.js';
  import LoopSource from '@Components/LoopSource/component.js';
  import PoweredBy from '@Components/PoweredBy/component.js';
  import ChallengeViewer from '@Components/ChallengeViewer/component.js';

  import { Utils } from '@Services';
  
  export let frontCamera = null;
  export let backCamera = null;
  export let poster = 'https://vod-d-ns-sessions.s3.amazonaws.com/014/Front/Thumbnails/poster-014.jpg';
  export let videoClass = 'default-player';
  export let videoPlayer = null;
  export let sessionId = '014';

  let frontBlobUrl = null;
  let backBlobUrl = null;

  const DEBUG = document.location.protocol === 'http:' ? true : false;

  let mediaSource = null;
  let challengeModeSupported = true;
  let streamBlobs = [];

  try {
    mediaSource = new MediaSource();
  }catch (error) {
    challengeModeSupported = false;
    console.warn('Device does not support MediaSource');
  }
  
  const dispatch = createEventDispatcher();

  let classSteps = [
    0, 
    35, 
    65,
    105, 
    135, 
    175,
  ];

  let recordedBlobs;
  let mediaRecorder;
  let sourceBuffer;
  let challengeVideo = null;
  let webCameraOptions = {};
  let webcamStream;

  let mobileCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  let getStreamBlob = async (stream, mode) => {
    const directory = stream.match(/^.*\//);
    const response = await fetch(stream);
    const text = await response.text();
    const updated = text.split('Session').join('https://vod-d-ns-sessions.s3.amazonaws.com/' + sessionId + '/' + mode + '/HLS/Session');
    return new Blob([updated], { type: "application/x-mpegURL" });
  };

  let getVideoStream = async (stream, mode) => {
    if (!stream) {
      return;
    }
    if (!streamBlobs[stream]) {
      streamBlobs[stream] = await getStreamBlob(stream, mode);
    }
    return window.URL.createObjectURL(streamBlobs[stream]);
  };

  let startVideo = () => {
    videoPlayer.play();
  };

  let onPlayerReady = (player) => {
    player.volume(1);
    player.addClass('d-ns-video-player');
  };

  let resetPlayerToLoop = (loopSource) => {
    // rounding to nearest int
    if (videoPlayer.paused()) {
      return;
    }
    const currentTime = Math.round(videoPlayer.currentTime());
    if ((currentTime >= Math.round(loopSource.startIndicator._currentTime)) && (currentTime <= Math.round(loopSource.endIndicator._currentTime))) {
      return;
    }
    videoPlayer.currentTime(loopSource.startIndicator._currentTime);
    if (DEBUG) console.log('re-set timer');
  };

  let handleSourceOpen = (event) => {
    sourceBuffer = mediaSource.addSourceBuffer('video/webm; codecs="vp8"');
  }

  let handleCameraSuccess = (stream) => {
    window.stream = stream;

    challengeVideo = document.querySelector('video#challengeCamera');
    challengeVideo.srcObject = stream;
  }

  let disposeCamera = () => {
    challengeVideo = document.querySelector('video#challengeCamera');
    challengeVideo.removeAttribute('src');
    challengeVideo.load();
    // close camera
    if (window.stream) {
      window.stream.getTracks().forEach(function(track) {
        track.stop();
      });
    }
  };

  async function initWebCam(constraints) {
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      handleCameraSuccess(stream);
      if (!videoPlayer.isFullscreen()) {
        mobiscroll.alert({
          title: '¡Estamos listos para grabar tu sesión!',
          message: 'Preparate y cuando estés listo presiona el botón de grabar ( <span style="color: red;">' + '\u2B24' + '</span> ). Después de eso tendrás cinco tiempos antes de iniciar la grabación.',
          callback: function () {
          }
        });
      }
    } catch (e) {
      mobiscroll.alert({
        title: 'Hubo un error al iniciar la cámara',
        message: e,
        callback: function () {
          // close challenge mode
          videoPlayer.getChild('ControlBar').getChild('OpenCamera').handleClick();
        }
      });
    }
  };

  let initChallengeMode = async () => {
    const constraints = {
      audio: {
        echoCancellation: false
      },
      video: {
        width: 1280, height: 720
      }
    };
    await initWebCam(constraints);

    dispatch('challengeMode', {
      status: true,
    });
  };

  let handleDataAvailable = (event) => {
    if (event.data && event.data.size > 0) {
      recordedBlobs.push(event.data);
    }
  };

  let startRecording = () => {
    recordedBlobs = [];
    // trying first with mobile settings for mp4
    webCameraOptions = {
      audioBitsPerSecond: 128000,
      videoBitsPerSecond: 2500000,
      mimeType: 'video/mp4'
    };
    if (!MediaRecorder.isTypeSupported(webCameraOptions.mimeType)) {
      console.warn(`${webCameraOptions.mimeType} is not Supported`);
      webCameraOptions = {
        audioBitsPerSecond: 128000,
        videoBitsPerSecond: 2500000,
        mimeType: 'video/mp4; codecs="avc1.424028, mp4a.40.2"'
      };
      if (!MediaRecorder.isTypeSupported(webCameraOptions.mimeType)) {
        console.warn(`${webCameraOptions.mimeType} is not Supported`);
        webCameraOptions = {mimeType: 'video/webm;codecs=vp9'};
        if (!MediaRecorder.isTypeSupported(webCameraOptions.mimeType)) {
          console.warn(`${webCameraOptions.mimeType} is not Supported`);
          webCameraOptions = {mimeType: 'video/webm;codecs=vp8'};
          if (!MediaRecorder.isTypeSupported(optwebCameraOptionsions.mimeType)) {
            console.warn(`${webCameraOptions.mimeType} is not Supported`);
            webCameraOptions = {mimeType: 'video/webm'};
            if (!MediaRecorder.isTypeSupported(webCameraOptions.mimeType)) {
              console.error(`${webCameraOptions.mimeType} is not Supported`);
              webCameraOptions = {mimeType: ''};
            }
          }
        }
      }
    }

    try {
      mediaRecorder = new MediaRecorder(window.stream, webCameraOptions);
    } catch (e) {
      console.error('Exception while creating MediaRecorder:', e);
      return;
    }

    mediaRecorder.onstop = (event) => {};
    mediaRecorder.ondataavailable = handleDataAvailable;
    mediaRecorder.start(10); // collect 10ms of data
  };

  let stopRecording = () => {
    if (window.stream) {
      mediaRecorder.stop();
      if (!videoPlayer.isFullscreen()) {
        mobiscroll.alert({
          title: '¡Tu video está listo!',
          message: 'Descarga tu video y compartelo en tus redes sociales, no olvides utilizar el hashtag <a href="#">#d-ns</a> <a href="#">#challenge</a>',
          callback: function () {
            downloadRecording();
          }
        });
      }
    }
  };

  let addRecCountDown = () => {
    let recTimer = 5;
    let ModalDialog = videojs.getComponent('ModalDialog');
    let h1Timer = document.createElement('div');
    h1Timer.className = 'rec-timer-counter';
    h1Timer.innerHTML = recTimer;
    const recOptions = {
      content: h1Timer
    };
    let recTimeoutModal = new ModalDialog(videoPlayer, recOptions);
    videoPlayer.addChild(recTimeoutModal);
    recTimeoutModal.open();
    const recTimeout = setInterval(() => {
      recTimer--;
      h1Timer.innerHTML = recTimer;
      if (recTimer < 1) {
        recTimeoutModal.close();
        clearInterval(recTimeout);
        if (videoPlayer.paused()) {
          videoPlayer.play();
        }
        startRecording();
      }
    }, 1500);
  };

  let closeChallengeMode = () => {
    dispatch('challengeMode', {
      status: false,
    });
    disposeCamera();
  };

  let downloadRecording = () => {
    if (!recordedBlobs || recordedBlobs.length === 0) {
      if (!videoPlayer.isFullscreen()) {
        mobiscroll.alert({
          title: 'No hay nada grabado aún',
          message: 'Inicia la webcam, da click en el botón de grabar y después podrás descargar tu video.',
          callback: function () {}
        });
      }
      return;
    }
    const blob = new Blob(recordedBlobs, {type: webCameraOptions.mimeType});
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    const d = new Date();
    const y = new Intl.DateTimeFormat('es', { year: 'numeric' }).format(d)
    const mo = new Intl.DateTimeFormat('es', { month: 'numeric' }).format(d)
    const day = new Intl.DateTimeFormat('es', { day: '2-digit' }).format(d)
    a.download = `d-ns-challenge-${day}-${mo}-${y}.mp4`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
  };

  afterUpdate(() => {
    if (videoPlayer === null) {
      const videoMainEl = document.querySelector('.' + videoClass);
      if (DEBUG) console.log('Loading player: .' + videoClass);
      if (videoMainEl === null) {
        return;
      }
      videoPlayer = videojs(videoMainEl, {
        controls: true,
        preload: 'metadata',
        aspectRatio: '16:9',
        nativeControlsForTouch: false,
        loop: false,
        html5: { 
          hls: { 
            overrideNative: true 
          }, 
          nativeVideoTracks: false, 
          nativeAudioTracks: false, 
          nativeTextTracks: false
        },
      });
      videoPlayer.fluid(true);
      let controlBar = videoPlayer.getChild('ControlBar');
      controlBar.removeChild('PlayToggle');
      controlBar.removeChild('PictureInPictureToggle');
      controlBar.removeChild('CurrentTimeDisplay');
      controlBar.removeChild('DurationDisplay');
      controlBar.removeChild('RemainingTimeDisplay');
      controlBar.removeChild('ProgressControl');
      controlBar.removeChild('FullscreenToggle');

      controlBar.addChild('MirrorSource');
      controlBar.addChild('ToggleSource');
      if (challengeModeSupported) {
        controlBar.addChild('OpenCamera');
        controlBar.addChild('StartRecording');
        controlBar.addChild('DownloadVideo');
      }
      controlBar.addChild('CustomControlSpacer');
      controlBar.addChild('FullscreenToggle');
      controlBar.addChild('PoweredBy', {
        sponsor: 'Semantic Weapons',
        sponsoredUrl: 'https://www.semanticweapons.com',
      });

      videoPlayer.addChild('DNSBar');
      const dnsBar = videoPlayer.getChild('DNSBar');
      dnsBar.removeChild('VolumePanel');
      dnsBar.removeChild('DurationDisplay');
      dnsBar.removeChild('RemainingTimeDisplay');
      dnsBar.removeChild('PictureInPictureToggle');
      dnsBar.removeChild('ProgressControl');
      dnsBar.removeChild('FullscreenToggle');
      // Add custom elements
      dnsBar.addChild('LoopSource');
      let loopSource = dnsBar.getChild('LoopSource');
      let seekBar = loopSource.getChild('seekBar');
      loopSource.on('startLoop', (event) => {
        if (DEBUG) console.log('[VideoPlayer] Starting loop...');
        clearInterval(loopSource._loopTimeOut);
        loopSource._loopTimeOut = setInterval(() => {
          if (LoopSource.loopMode) {
            resetPlayerToLoop(loopSource);
          }
        }, 1500);
      });
      if (Utils.isMobile()) {
        seekBar.on('tap', (event) => {
          if (DEBUG) console.log('[VideoPlayer] Tap on loopSource: ' + event);
          loopSource.handleMouseMove(event);
        });
        seekBar.on('touchstart', (event) => {
          if (DEBUG) console.log('[VideoPlayer] touchstart on SeekBar: ' + event);
          loopSource.handleMouseMove(event);
        });
        seekBar.on('touchmove', (event) => {
          if (DEBUG) console.log('[VideoPlayer] touchmove on SeekBar: ' + event);
          loopSource.handleMouseMove(event);
        });
        seekBar.on('touchend', (event) => {
          if (DEBUG) console.log('[VideoPlayer] touchend on SeekBar: ' + event);
          loopSource.handleMouseDown(event);
        });
      }else{
        loopSource.on('tap', (event) => {
          if (DEBUG) console.log('[VideoPlayer] Tap on loopSource: ' + event);
          loopSource.handleMouseDown(event);
        });
        loopSource.on('click', (event) => {
          if (DEBUG) console.log('[VideoPlayer] Click on loopSource: ' + event);
          loopSource.handleMouseMove(event);
        });
        seekBar.on('click', (event) => {
          if (DEBUG) console.log('[VideoPlayer] click on SeekBar: ' + event);
          loopSource.handleMouseDown(event);
        });
      }
      dnsBar.addChild('LoopSourceButton', {});
      // bind challenge mode
      videoPlayer.on('challengeOn', async function(event) {
        initChallengeMode();
      });
      videoPlayer.on('stopRecording', function(event) {
        if (DEBUG) console.log('[VideoPlayer] Stop recording...');
        stopRecording();
      });
      videoPlayer.on('downloadRecording', function(event) {
        if (DEBUG) console.log('[VideoPlayer] Download recording...');
        downloadRecording();
      });
      videoPlayer.on('readyToRecord', function(event) {
        if (DEBUG) console.log('[VideoPlayer] Ready to start recording...');
        addRecCountDown();
      });
      videoPlayer.on('notReadyToRecord', function(event) {
        if (DEBUG) console.log('[VideoPlayer] Ready to start recording...');
        // @TODO: this won't work once iOS is supported
        mobiscroll.confirm({
          title: '¿Desea iniciar la cámara web?',
          message: 'Antes de empezar a grabar necesitas iniciar la cámara web. ¿Deseas hacerlo ahora?',
          okText: '¡Si!',
          cancelText: 'Todavía no',
          callback: function (res) {
            if (res) {
              initChallengeMode();
            }
          }
        });
      });
      videoPlayer.on('challengeOff', function(event) {
        closeChallengeMode();
      });
      videoPlayer.ready(onPlayerReady(videoPlayer));
    }
  });

  onMount(async () =>{
    if (!mobileCheck()) {
      if (frontCamera) {
        frontBlobUrl = await getVideoStream(frontCamera, 'Front');
      }
      if (backCamera) {
        backBlobUrl = await getVideoStream(backCamera, 'Back'); 
      }
    }
    videojs.options.autoplay = false;
    // Setup break points
    videojs.options.breakpoints = {
      tiny: 568,
      xsmall: 667,
      small: 736,
      medium: 812,
      large: 1024,
      xlarge: 1200,
      huge: 1366,
    };
    videojs.options.playbackRates = [
      0.5,
      1,
      1.5,
      1.75,
      2,
    ];

    if (challengeModeSupported) {
      mediaSource.addEventListener('sourceopen', handleSourceOpen, false);
    }
  });
</script>
